<template>
  <div
    v-if="logged_in && (state === 'pending_cancel' || state === 'cancelled')"
    class="cancel-banner"
    :class="state === 'cancelled' ? 'cancel-banner--hard' : 'cancel-banner--warn'"
  >
    <div class="cancel-banner-inner">
      <span class="cancel-banner-icon">⚠</span>
      <div class="cancel-banner-text">
        <strong v-if="state === 'pending_cancel'">Your Kiey account will end{{ effective_text ? ' on ' + effective_text : '' }}.</strong>
        <strong v-else-if="state === 'cancelled'">This Kiey account has been cancelled.</strong>
        <span class="cancel-banner-secondary">
          Email <a href="mailto:support@kiey.com">support@kiey.com</a> with questions.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CancellationBanner',
  computed: {
    ...mapGetters('Authenticate', {
      logged_in: 'isLoggedIn',
      state: 'tenant_billing_state',
      effective_at: 'tenant_cancel_effective_at',
    }),
    effective_text() {
      if (!this.effective_at) return null;
      const d = new Date(this.effective_at);
      if (isNaN(d.getTime())) return null;
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    },
  },
};
</script>

<style scoped>
.cancel-banner {
  width: 100%;
  padding: 10px 16px;
  font-size: 14px;
  line-height: 1.4;
  border-bottom: 1px solid transparent;
}
.cancel-banner--warn {
  background: #fff4e0;
  color: #92580b;
  border-bottom-color: #f0c97d;
}
.cancel-banner--hard {
  background: #fde6e6;
  color: #8a1f1f;
  border-bottom-color: #e8a4a4;
}
.cancel-banner-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.cancel-banner-icon {
  font-size: 16px;
  line-height: 1.4;
}
.cancel-banner-text strong { margin-right: 6px; }
.cancel-banner-secondary { font-weight: 400; }
.cancel-banner a {
  color: inherit;
  text-decoration: underline;
}
</style>
